module.exports = __webpack_public_path__ + "img/people_hsb.8d3f5f81.jpg";